<pos-app-spinner [show]="isCreatingCustomer"></pos-app-spinner>
<div *ngIf="!checkingDuplicate && !(duplicateCustomers$ | async) || (duplicateCustomers$ | async)?.length === 0">
  <app-customers-ship-to-form
    (formChanged)="formValue = $event"
    (formIsValid)="formValid = $event"
    (formIsDirty)="formDirtyHandler($event)"
    [soldToCustomer]="selectedCustomerDetails$ | async"
    [lookupLists]="lookupLists$ | async"
    (submitByEnter)="formValid && checkDuplicate()"
    (cancelled)="cancel()"
    (selectedCountry)="getFilteredStateList($event)"
    [filteredStateList]="filteredStateList"
  >
  </app-customers-ship-to-form>

  <div class="d-flex float-end pb-5">
    <button class="col-sm-6 btn btn-cancel m-2" (click)="cancel()">CANCEL</button>
    <button class="col-sm-4 btn text-white m-2" [disabled]="!formValid" (click)="checkDuplicate()">SAVE</button>
  </div>
</div>
<ng-container *ngIf="(duplicateCustomers$ | async) && (duplicateCustomers$ | async)?.length > 0">
  <app-customers-duplicate
    [setNewCustomerDetails]="newCustomerDetails"
    [setDuplicateCustomers]="duplicateCustomers$ | async"
    (customerChoosen)="customerChoosen($event)"
    (cancelled)="cancel()"
  >
  </app-customers-duplicate>
</ng-container>
<div id="bottom"></div>
